import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createMultiYAxisSlice } from './multiYAxis';
import { createDataStreamsSlice } from './contextDataStreams';
import { createMinMaxSlice } from './dataStreamMinMaxStore';
export const createChartStore = (initProps) => create()(devtools(persist((...args) => ({
    ...initProps,
    ...createMultiYAxisSlice(...args),
    ...createDataStreamsSlice(...args),
    ...createMinMaxSlice(...args),
}), { name: `chart-store-${initProps === null || initProps === void 0 ? void 0 : initProps.chartId}` })));
